import { FunctionComponent } from "react";

export interface Props {
  className?: string;
  fill?: string;
  width?: number;
  height?: number;
}
const HamburgerIcon: FunctionComponent<Props> = ({
  className,
  fill = "currentColor",
  width = 23,
  height = 17,
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 23 17"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="0.867188"
        y1="1.53857"
        x2="22.8672"
        y2="1.53857"
        stroke={fill}
        strokeWidth="2"
      />
      <line
        x1="0.867188"
        y1="8.53857"
        x2="22.8672"
        y2="8.53857"
        stroke={fill}
        strokeWidth="2"
      />
      <line
        x1="0.867188"
        y1="15.5386"
        x2="22.8672"
        y2="15.5386"
        stroke={fill}
        strokeWidth="2"
      />
    </svg>
  );
};

export default HamburgerIcon;
